import React from "react";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateMasterGoalPayload, MasterGoal } from "./ipmsmodel";
import { useManageIPMSContext } from "./ManageIPMSContex";
import SingleSelect from "../../components/SingleSelect";

const defaultValue: CreateMasterGoalPayload = {
  goal: "",
  goaltype: "",
  status: true,
  department: "All",
  // department: "BPO",
};

const CreateUpdateGoalsForm: React.FC<{ formType: string }> = ({ formType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { item: MasterGoal | null, goalTypeOption: string[] } | undefined; // Assuming state is an object with an 'id' property
  // Access 'id' from state if it exists
  const editcontent = state?.item;
  //   const getUserId = getUserIdTokenForIPMSEmployid();
  const { listDepartment, getAllDepartment, addandupdateGoals } = useManageIPMSContext();

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<CreateMasterGoalPayload>({ mode: "all", defaultValues: defaultValue });

  React.useEffect(() => {
    reset(defaultValue);
    getAllDepartment({ skip: 0, limit: 50 });
    if (editcontent && formType === "update") {
      setValue("goal", editcontent.goal);
      setValue("goaltype", editcontent.goaltype);
      setValue("status", editcontent.status ?? true);
      setValue("department", editcontent.department ?? 'All');
    }
  }, [reset, setValue]);

  const onSubmit: SubmitHandler<CreateMasterGoalPayload> = async (data) => {
    console.log("submit", data, formType);
    await addandupdateGoals(data, formType, editcontent ? editcontent.id : null);
    return;
  };

  return (
    <form
      className='max-w-4xl grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 '
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className='mb-2 col-span-full'>
        <label htmlFor='manager' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Goals <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='goal'
          control={control}
          rules={{ required: "Goals is required" }}
          render={({ field }) => (
            <textarea
              {...field}
              value={field.value}
              rows={5}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          )}
        />
        {errors.goal && <p className='text-red-500 text-sm mt-1'>{errors.goal.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Goal type <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='goaltype'
          control={control}
          rules={{ required: "Goal type is required" }}
          render={({ field }) => (
            <SingleSelect
              {...field}
              options={state?.goalTypeOption.map((item) => ({ value: item, label: item }))}
              value={field.value ? { value: field.value, label: field.value } : null}
              onChange={(option: any) => field.onChange(option?.value)}
              placeholder="Select Goal Type"
              className="mt-0 "
            />
          )}
        />
        {errors.status && <p className='text-red-500 text-sm mt-1'>{errors.status.message}</p>}
      </div>

      <div className='mb-2'>
        <label htmlFor='status' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Status <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='status'
          control={control}
          rules={{ required: "Status is required" }}
          render={({ field }) => (
            <SingleSelect
              {...field}
              options={[
                { value: true, label: "Active" },
                { value: false, label: "InActive" },
              ]}
              value={
                field.value === true ? { value: true, label: "Active" } :
                  field.value === false ? { value: false, label: "InActive" } : null
              }
              onChange={(option: any) => field.onChange(option?.value)}
              placeholder="Select Status"
              className="mt-0"
            />
          )}
        />
        {errors.status && <p className='text-red-500 text-sm mt-1'>{errors.status.message}</p>}
      </div>
      <div className='mb-2'>
        <label htmlFor='altManager' className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
          Department <span className='text-red-400'>*</span>
        </label>
        <Controller
          name='department'
          control={control}
          rules={{ required: "Department is required" }}
          render={({ field }) => (
            <SingleSelect
              {...field}
              options={[
                { value: 'All', label: 'All' },
                ...(listDepartment?.map((item) => ({ value: item.department, label: item.department })) || []),
              ]}
              value={field.value ? { value: field.value, label: field.value } : null}
              onChange={(option: any) => field.onChange(option?.value)}
              placeholder="Select Department"
              className="mt-0"
            />
          )}
        />
        {errors.department && <p className='text-red-500 text-sm mt-1'>{errors.department.message}</p>}
      </div>

      <div className='max-w-4xl col-span-full'>
        <button
          type='submit'
          className='text-white bg-blue-700 mr-2 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
        >
          Save
        </button>
        <button
          type='button'
          onClick={() => navigate(-1)}
          className='text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800'
        >
          Close
        </button>
      </div>
    </form>
  );
};

export default CreateUpdateGoalsForm;
